// No roles means unrestricted.
export function userHasRole(user, roles) {
  if (!roles || roles.length === 0) {
    return true
  }
  if (!user || !user.role) {
    return false
  }
  return roles.includes(user.role.toLowerCase())
}
